import dayjs from "dayjs";

import { ChartColorTuple, blue, green, orange, violet, yellow } from "@/config/chart_colors";
import { formatCurrency } from "@/utils/formatEuro";
import { getColorFromTransitionStatus } from "@/utils/getColorFromTransitionStatus";

import type { AuctionCarTransaction } from "@/types/auctions";
import type { Currency } from "@/types/currency";

const colors: Record<string, ChartColorTuple> = {
  blue,
  green,
  orange,
  violet,
  yellow,
};

export function getDataAndDomain(
  transactions: AuctionCarTransaction[],
  currency: Currency,
  colorShade = 3
) {
  let minDate = Infinity;

  const data = transactions.map((transaction) => {
    const date = dayjs(transaction.date).unix();
    if (date < minDate) minDate = date;

    return {
      color: getColor(getColorFromTransitionStatus(transaction.status), colorShade),
      name: formatCurrency(transaction.price, currency.code, { notation: "standard" }),
      data: [
        {
          date,
          value: transaction.price,
        },
      ],
    };
  });

  minDate = dayjs.unix(minDate).startOf("year").unix();

  return {
    data,
    domain: [minDate, dayjs().unix()],
  };
}

function getColor(name: string, shade: number) {
  if (colors[name]) {
    return colors[name][shade];
  }
  return `${name}.${shade}`;
}
